import moment from 'moment'
import i18n from 'i18next'
import { membershipNameType } from '../utils/constant'

// import * as crypto from 'crypto-js'

export function toUpperFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function momentToMilis(mnt: any) {
  return ((mnt.get('h') - 1) * 60 * 60 + mnt.get('m') * 60 + mnt.get('s')) * 1000
}

/* function unescapeHTML(htmlString: string) {
  const escapeEl = document.createElement('textarea')
  escapeEl.innerHTML = htmlString
  return escapeEl.textContent
} */

export function extractDefinition(storyContent: string) {
  if (storyContent) {
    const arSentences = storyContent.split(',')
    const filtered = arSentences.filter((arSentence) => !arSentence.includes('CL:') || !arSentence.includes('cl:'))
    if (filtered && filtered.length > 0) {
      if (filtered.length > 3) {
        filtered.splice(3, filtered.length - 3)
      }
      return `<span>${filtered.join('</span>,<span>')}</span>`
    }
    return `<span>${storyContent}</span>`
  }
  return ''
}

export function convertAudioTime(time) {
  if (!isNaN(time)) {
    return Math.floor(time / 60) + ':' + ('0' + Math.floor(time % 60)).slice(-2)
  }
}

export const idValidAccount = (userMemberShipTypeName = '') => {
  if (!userMemberShipTypeName) return false
  return (
    userMemberShipTypeName.toLowerCase() === membershipNameType.School.toLowerCase() ||
    userMemberShipTypeName.toLowerCase() === membershipNameType.Premium.toLowerCase() ||
    userMemberShipTypeName.toLowerCase() === membershipNameType.Weekly.toLowerCase() ||
    userMemberShipTypeName.toLowerCase() === membershipNameType.Standard.toLowerCase() ||
    userMemberShipTypeName.toLowerCase() === membershipNameType.Pro.toLowerCase() ||
    userMemberShipTypeName.toLowerCase() === membershipNameType.Teacher.toLowerCase()
  )
}

// Weekday number, not the formatted name, so it holds whatever moment's locale is (0 is Sunday).
export const isSunday = () => moment.utc().day() === 0

// export function encryptData(data: string, publicKey: string): string {
//   try {
//     const encryptedData = crypto.publicEncrypt(
//       {
//         key: publicKey,
//         padding: crypto.constants.RSA_PKCS1_OAEP_PADDING,
//         oaepHash: 'sha256',
//       },
//       Buffer.from(data),
//     )
//     // console.log(encryptedData.toString('base64'))
//     return encryptedData.toString('base64')
//   } catch (error) {
//     console.log({ error })
//     return ''
//   }
// }

export const parseQuery = (queryString) => {
  if (!queryString) return ''
  const query = {}
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&')
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=')
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '')
  }
  return query
}

/**
 * How long ago an epoch-milliseconds time was, as a bare duration ("3 days"): callers add "ago".
 * Prefer formatRelative (i18n/format.ts) for new code, which words the whole "3 days ago".
 * The units live in `common` because this runs outside React.
 */
export const epochTimeDifferenceInText = (time) => {
  const currentDate = moment()
  const pastDate = moment.unix(parseInt(time) / 1000)
  const diffYears = currentDate.diff(pastDate, 'year')
  const diffMonths = currentDate.diff(pastDate, 'months')
  const diffDays = currentDate.diff(pastDate, 'days')
  const diffHours = currentDate.diff(pastDate, 'hours')
  const diffMinutes = currentDate.diff(pastDate, 'minutes')
  return diffYears
    ? i18n.t('common:duration.years', { count: diffYears })
    : diffMonths
      ? i18n.t('common:duration.months', { count: diffMonths })
      : diffDays
        ? i18n.t('common:duration.days', { count: diffDays })
        : diffHours
          ? i18n.t('common:duration.hours', { count: diffHours })
          : i18n.t('common:duration.minutes', { count: diffMinutes })
}

/** Why an answer was refused: a code to branch on, and `error` to show (in the interface language). */
export type AnswerValidation = { error: string; code?: 'tooShort' | 'notChinese' }

export const answerValidate = async (answer): Promise<AnswerValidation> => {
  if (answer.length < 5) {
    return { error: i18n.t('common:validation.answerTooShort'), code: 'tooShort' }
  }

  const chineseChars = (answer.match(/\p{Script=Han}/gu) || []).length
  const latinChars = (answer.match(/[a-zA-Z]/g) || []).length
  const totalMeaningful = chineseChars + latinChars

  if (totalMeaningful === 0 || chineseChars / totalMeaningful < 0.8) {
    return { error: i18n.t('common:validation.answerNotChinese'), code: 'notChinese' }
  }

  return { error: '' }
}

export const getBlobDuration = async (blob): Promise<number> => {
  const tempAudioEl = new Audio(blob)
  tempAudioEl.preload = 'metadata'
  tempAudioEl.muted = true

  const durationP: Promise<number> = new Promise((resolve, reject) => {
    tempAudioEl.addEventListener('canplay', async () => {
      tempAudioEl.play()
    })
    tempAudioEl.addEventListener('loadedmetadata', () => {
      if (tempAudioEl.duration === Infinity) {
        // When Infinity Duration
        tempAudioEl.currentTime = Number.MAX_SAFE_INTEGER
        tempAudioEl.ontimeupdate = () => {
          if (tempAudioEl.duration !== Infinity) {
            tempAudioEl.ontimeupdate = () => {
              return
            }
            tempAudioEl.currentTime = 0
            tempAudioEl.pause()
            resolve(tempAudioEl.duration)
          }
        }
      } else resolve(tempAudioEl.duration) // Normal behavior
    })
    tempAudioEl.onerror = (event) => reject(event)
  })

  return durationP
}
